import { DangerAlert } from "components/common/Alerts";
import "components/common/Common.css";
import CustomerSelect from "components/common/CustomerSelect";
import SalesPersonSelect from "components/common/SalesPersonSelect";
import Select2 from "components/common/Select2";
import serialize from "form-serialize";
import QuoteCustomer from "interfaces/QuoteCustomer";
import * as React from "react";
import { Option } from "react-select";
import MaskedInput from "react-text-mask";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";
import normalizePhone from "utils/normalizePhone";

interface Props {
    onSubmit: Function;
    onCancel: Function;
    isNewQuote: boolean;
    isDraft: boolean;
    isMasterQuote: boolean;
    customers: QuoteCustomer[];
}

interface State {
    addNew: boolean;
    addNewContact: boolean;
    hasValidationErrors: boolean;
    validationMessage: string;
    contactPersonCount: number;
    customers: QuoteCustomer[];
    contacts: {
        id: number;
        name: string;
        email: string;
    }[];
    customerContactId?: number;
    customerContactName?: string;
    customerContactEmail?: string;
    isCustomerSelected: boolean;
    //errors: {
    //    customerContactEmail: boolean;
    //};
}

export default class Step2 extends React.Component<Props, State> {
    private baseUrl: string;
    private formRef: React.RefObject<HTMLFormElement>;
    private customerSelectRef: React.RefObject<CustomerSelect>;

    public constructor(props: Props) {
        super(props);

        let state: State = {
            addNew: false,
            addNewContact: false,
            hasValidationErrors: false,
            validationMessage: "",
            contactPersonCount: 1,
            customers: this.props.isMasterQuote ? this.props.customers : [],
            contacts: [],
            isCustomerSelected: false,
            //errors: {
            //    customerContactEmail: false,
            //},
        };

        if (this.props.customers.length !== 0 && !this.props.isMasterQuote) {
            state.addNewContact = this.props.customers[0].isNewContact;
            state.customerContactId = this.props.customers[0].customerContactId;
            state.customerContactName = this.props.customers[0].customerContactName;
            state.customerContactEmail = this.props.customers[0].customerContactEmail;
            state.isCustomerSelected = true;
        }

        this.state = state;

        this.baseUrl = document
            .getElementsByTagName("base")[0]
            .getAttribute("href")!;
        this.formRef = React.createRef();
        this.customerSelectRef = React.createRef();

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitAsDraft = this.handleSubmitAsDraft.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleAddContactClicked = this.handleAddContactClicked.bind(this);
        this.handleAddNewChanged = this.handleAddNewChanged.bind(this);
        this.handleAddNewContactChanged =
            this.handleAddNewContactChanged.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.handleBooleanInputChanged = this.handleBooleanInputChanged.bind(this);
        this.handleNumberInputChanged = this.handleNumberInputChanged.bind(this);
        this.handleCustomerRemoved = this.handleCustomerRemoved.bind(this);
        this.handleCustomerSelected = this.handleCustomerSelected.bind(this);
        this.handleAddCustomer = this.handleAddCustomer.bind(this);
        this.getCustomerContacts = this.getCustomerContacts.bind(this);

        //this.handleInputEmailChanged = this.handleInputEmailChanged.bind(this);
    }

    public render() {
        var contacts = [];
        for (let i = 0; i < this.state.contactPersonCount; i++) {
            contacts.push(<ContactPerson key={i} contactNumber={i} />);
        }

        return (
            <div className="card card--form">
                <div className="card-block">
                    <form name="form" className="form" ref={this.formRef}>
                        <h2 className="card__title">Select or Add New Customer</h2>
                        <div className="form-wrapper">
                            {this.state.hasValidationErrors && (
                                <DangerAlert name="dangerAlert">An error occured.</DangerAlert>
                            )}
                            <div className="row">
                                <div className="field-group col-sm-12 mt-3 mb-3">
                                    <span className="field-label mt-0">New Customer</span>
                                    <p className="custom-checkbox-wrap">
                                        <input
                                            className="custom-checkbox"
                                            id="add-new-customer-yes"
                                            name="addNew"
                                            type="radio"
                                            value="true"
                                            onClick={this.handleBooleanInputChanged}
                                        />
                                        <label htmlFor="add-new-customer-yes">Yes</label>
                                    </p>
                                    <p className="custom-checkbox-wrap">
                                        <input
                                            className="custom-checkbox"
                                            id="add-new-customer-no"
                                            name="addNew"
                                            type="radio"
                                            value="false"
                                            onClick={this.handleBooleanInputChanged}
                                            defaultChecked={true}
                                        />
                                        <label htmlFor="add-new-customer-no">No</label>
                                    </p>
                                </div>
                            </div>
                            {this.state.addNew ? (
                                <div>
                                    <div className="row">
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">Mincron ID</span>
                                            <input
                                                type="text"
                                                name="mincronId"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="field-group col-sm-12">
                                            <span className="field-label">Name</span>
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control"
                                                required
                                                maxLength={50}
                                                onInput={(e) => e.currentTarget.setCustomValidity("")}
                                                onInvalid={(e) =>
                                                    e.currentTarget.setCustomValidity(
                                                        "Customer name is required."
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">Address</span>
                                            <input
                                                type="text"
                                                name="address"
                                                className="form-control"
                                                maxLength={50}
                                            />
                                        </div>
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">City</span>
                                            <input
                                                type="text"
                                                name="city"
                                                className="form-control"
                                                required
                                                maxLength={50}
                                                onInput={(e) => e.currentTarget.setCustomValidity("")}
                                                onInvalid={(e) =>
                                                    e.currentTarget.setCustomValidity("City is required.")
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">Address 2</span>
                                            <input
                                                type="text"
                                                name="address2"
                                                className="form-control"
                                                maxLength={50}
                                            />
                                        </div>
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">State</span>
                                            <input
                                                type="text"
                                                name="state"
                                                className="form-control"
                                                pattern="[A-Za-z]{2}"
                                                maxLength={2}
                                                onInput={(e) => e.currentTarget.setCustomValidity("")}
                                                onInvalid={(e) =>
                                                    e.currentTarget.setCustomValidity(
                                                        "State must be a 2 character abbreviation."
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">Address 3</span>
                                            <input
                                                type="text"
                                                name="address3"
                                                className="form-control"
                                                maxLength={50}
                                            />
                                        </div>
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">Zip</span>
                                            <input
                                                type="text"
                                                name="zip"
                                                className="form-control"
                                                required
                                                pattern="[0-9]{5}"
                                                maxLength={5}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">Phone</span>
                                            <MaskedInput
                                                mask={[
                                                    "(",
                                                    /[1-9]/,
                                                    /\d/,
                                                    /\d/,
                                                    ")",
                                                    " ",
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                    "-",
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                ]}
                                                name="phone"
                                                className="form-control"
                                                placeholder="(xxx) xxx-xxxx"
                                                pattern="\(\d{3}\) \d{3}-\d{4}"
                                                onInput={(e) => e.currentTarget.setCustomValidity("")}
                                                onInvalid={(e) =>
                                                    e.currentTarget.setCustomValidity(
                                                        "Phone number must be in the format of (xxx) xxx-xxxx."
                                                    )
                                                }
                                            />
                                        </div>
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">Fax</span>
                                            <MaskedInput
                                                mask={[
                                                    "(",
                                                    /[1-9]/,
                                                    /\d/,
                                                    /\d/,
                                                    ")",
                                                    " ",
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                    "-",
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                ]}
                                                name="fax"
                                                className="form-control"
                                                placeholder="(xxx) xxx-xxxx"
                                                pattern="\(\d{3}\) \d{3}-\d{4}"
                                                onInput={(e) => e.currentTarget.setCustomValidity("")}
                                                onInvalid={(e) =>
                                                    e.currentTarget.setCustomValidity(
                                                        "Fax number must be in the format of (xxx) xxx-xxxx."
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">Salesperson</span>
                                            <SalesPersonSelect
                                                name="salesPerson"
                                                className="form-control"
                                                maxLength={50}
                                            />
                                        </div>
                                        <div className="field-group col-sm-6">
                                            <span className="field-label">Website</span>
                                            <input
                                                type="text"
                                                name="website"
                                                className="form-control"
                                                maxLength={50}
                                            />
                                        </div>
                                    </div>
                                    <h5 className="section-seprate">Contact Information</h5>
                                    {contacts}
                                    <div className="field-group">
                                        <a href="#" onClick={this.handleAddContactClicked}>
                                            Add Contact Person
                                        </a>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div className="row">
                                        <div className="field-group col-sm-12">
                                            <span className="field-label">Name</span>
                                            {this.props.customers.length !== 0 &&
                                                !this.props.isMasterQuote ? (
                                                <CustomerSelect
                                                    onItemSelect={this.handleCustomerSelected}
                                                    ref={this.customerSelectRef}
                                                    value={{
                                                        value: this.props.customers[0].customerId,
                                                        label: this.props.customers[0].customerName,
                                                    }}
                                                    includeInternal={true}
                                                />
                                            ) : (
                                                <CustomerSelect
                                                    onItemSelect={this.handleCustomerSelected}
                                                    ref={this.customerSelectRef}
                                                    includeInternal={true}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="field-group col-sm-12 mt-3 mb-3">
                                            <span className="field-label mt-0">New ATTN</span>
                                            <p className="custom-checkbox-wrap">
                                                <input
                                                    className="custom-checkbox"
                                                    id="add-new-contact-yes"
                                                    name="addNewContact"
                                                    type="radio"
                                                    value="true"
                                                    onClick={this.handleBooleanInputChanged}
                                                    checked={this.state.addNewContact}
                                                />{" "}
                                                <label htmlFor="add-new-contact-yes">Yes</label>
                                            </p>
                                            <p className="custom-checkbox-wrap">
                                                <input
                                                    className="custom-checkbox"
                                                    id="add-new-contact-no"
                                                    name="addNewContact"
                                                    type="radio"
                                                    value="false"
                                                    onClick={this.handleBooleanInputChanged}
                                                    checked={!this.state.addNewContact}
                                                />{" "}
                                                <label htmlFor="add-new-contact-no">No</label>
                                            </p>
                                        </div>
                                    </div>
                                    {this.state.addNewContact ? (
                                        <div className="row">
                                            <div className="field-group col-sm-6">
                                                <span className="field-label">ATTN Name</span>
                                                <input
                                                    type="text"
                                                    name="customerContactName"
                                                    className="form-control"
                                                    onChange={this.handleInputChanged}
                                                />
                                            </div>
                                            <div className="field-group col-sm-6">
                                                <span className="field-label">ATTN Email</span>
                                                <input
                                                    type="text"
                                                    name="customerContactEmail"
                                                    className="form-control"
                                                    pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
                                                    onChange={this.handleInputChanged}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="row">
                                            <div className="field-group col-sm-12">
                                                <span className="field-label">ATTN</span>
                                                {this.state.isCustomerSelected ? (
                                                    <select
                                                        name="customerContactId"
                                                        className="form-control"
                                                        onChange={this.handleNumberInputChanged}
                                                        value={this.state.customerContactId}
                                                    >
                                                        <option value="">Select a contact</option>
                                                        {this.state.contacts.map((item, index) => (
                                                            <option value={item.id}>{item.name}</option>
                                                        ))}
                                                    </select>
                                                ) : (
                                                    <span className="field-item">
                                                        Select a customer to see contacts.
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                            {this.props.isMasterQuote && (
                                <div className="button-actions text-center">
                                    <button
                                        className="btn btn-primary"
                                        onClick={this.handleAddCustomer}
                                    >
                                        Add Customer to Quote
                                    </button>
                                </div>
                            )}
                        </div>
                        <br />
                        {this.props.customers.length !== 0 && this.props.isMasterQuote && (
                            <div>
                                <h4 className="card__title">Customers Added to Quote</h4>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "70%" }}>Customer</th>
                                            <th style={{ width: "29%" }}>ATTN</th>
                                            <th style={{ width: "1%" }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.customers.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.customerName}</td>
                                                <td>{item.customerContactName}</td>
                                                <td className="text-center">
                                                    <a
                                                        href="#"
                                                        className="btn-delete"
                                                        onClick={(event) =>
                                                            this.handleCustomerRemoved(event, index)
                                                        }
                                                    >
                                                        <i className="icon-delete1"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        <div className="button-actions text-center">
                            <button
                                className="btn btn-primary"
                                onClick={(event) => this.handleSubmit(event, 1)}
                            >
                                Previous
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={(event) => this.handleSubmit(event, 3)}
                            >
                                Next
                            </button>
                            {(this.props.isNewQuote || this.props.isDraft) && (
                                <button
                                    className="btn btn-primary"
                                    onClick={this.handleSubmitAsDraft}
                                >
                                    Save as Draft
                                </button>
                            )}
                            <button className="btn-link" onClick={this.handleCancel}>
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    public async componentDidMount() {
        if (this.state.isCustomerSelected) {
            await this.getCustomerContacts(this.props.customers[0].customerId);

            if (
                !this.state.addNewContact &&
                this.state.contacts.length !== 0 &&
                this.state.customerContactName !== undefined &&
                !this.props.isMasterQuote
            ) {
                let customerContact = this.state.contacts.find(
                    (x) =>
                        x.name.toUpperCase() ===
                        this.state.customerContactName!.toUpperCase()
                );
                if (customerContact !== undefined) {
                    this.setState({
                        customerContactId: customerContact.id,
                    });
                } else {
                    this.setState({
                        addNewContact: true,
                    });
                }
            }
        }
    }

    private handleAddContactClicked(e: any) {
        e.preventDefault();
        this.setState({
            contactPersonCount: this.state.contactPersonCount + 1,
        });
    }

    private async handleAddCustomer(event?: React.FormEvent<HTMLButtonElement>) {
        if (event) {
            event.preventDefault();

            const form = event.currentTarget.form;
            if (form && !form.checkValidity()) {
                form.reportValidity();

                this.setState({ hasValidationErrors: true });

                return;
            }
        }

        if (this.state.hasValidationErrors) {
            this.setState({
                hasValidationErrors: false,
            });
        }

        let customerId = 0;
        let customerName = "";
        let isNewContact = false;
        let customerContactId: number | undefined = undefined;
        let customerContactName: string | undefined = undefined;
        let customerContactEmail: string | undefined = undefined;

        if (this.state.addNew) {
            let data = serialize(this.formRef.current!, { hash: true }) as any;

            // Normalize phone numbers (aaa) bbb-cccc to aaabbbcccc
            if (data.phone) {
                data.phone = normalizePhone(data.phone);
            }
            if (data.fax) {
                data.fax = normalizePhone(data.fax);
            }
            for (let i = 0; i < data.customerContacts.length; i++) {
                if (data.customerContacts[i].phone) {
                    data.customerContacts[i].phone = normalizePhone(
                        data.customerContacts[i].phone
                    );
                }
            }

            let response = await apifetch(
                "customers",
                {
                    headers: new Headers({
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    }),
                    method: "POST",
                    body: JSON.stringify(data),
                },
                true
            );
            if (response.ok) {
                let responseData = await response.json();
                customerId = responseData.id;
                customerName = data.name;
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    hasValidationErrors: true,
                    validationMessage: errorText,
                });
            }
        } else {
            let customer = this.customerSelectRef.current!.getCustomer();
            if (customer !== undefined) {
                customerId = customer.id;
                customerName = customer.name;

                if (this.state.addNewContact) {
                    isNewContact = true;
                    customerContactName = this.state.customerContactName!;
                    customerContactEmail = this.state.customerContactEmail!;
                } else {
                    if (this.state.customerContactId) {
                        for (let i = 0; i < this.state.contacts.length; i++) {
                            if (this.state.contacts[i].id === this.state.customerContactId) {
                                isNewContact = false;
                                customerContactId = this.state.contacts[i].id;
                                customerContactName = this.state.contacts[i].name;
                                customerContactEmail = this.state.contacts[i].email;
                                break;
                            }
                        }
                    } else {
                        isNewContact = true;
                        customerContactName = this.state.customerContactName;
                        customerContactEmail = this.state.customerContactEmail;
                    }
                }
            }
        }

        let customers = this.state.customers;

        if (
            customerId !== 0 &&
            !customers.some((x) => x.customerId === customerId)
        ) {
            customers.push({
                customerId: customerId,
                customerName: customerName,
                isNewContact: isNewContact,
                customerContactId: customerContactId,
                customerContactName: customerContactName,
                customerContactEmail: customerContactEmail,
            });
        }
        this.setState({
            customers: customers,
            isCustomerSelected: false,
        });

        if (!this.state.addNew) {
            this.customerSelectRef.current!.value = undefined;
        }
    }

    private async handleSubmit(
        event: React.MouseEvent<HTMLButtonElement>,
        nextStepNumber: number
    ) {
        event.preventDefault();

        if (this.state.hasValidationErrors) {
            this.setState({
                hasValidationErrors: false,
            });
        }

        // Get the customer information if this isn't a master quote
        if (!this.props.isMasterQuote) {
            await this.handleAddCustomer();
        }

        this.props.onSubmit({
            customers: this.state.customers,
            nextStepNumber: nextStepNumber,
        });
    }

    private async handleSubmitAsDraft(
        event: React.MouseEvent<HTMLButtonElement>
    ) {
        event.preventDefault();

        if (this.state.hasValidationErrors) {
            this.setState({
                hasValidationErrors: false,
            });
        }

        // Get the customer information if this isn't a master quote
        if (!this.props.isMasterQuote) {
            await this.handleAddCustomer();
        }

        this.props.onSubmit({
            customers: this.state.customers,
            saveAsDraft: true,
        });
    }

    private handleCancel(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        this.props.onCancel();
    }

    private handleInputChanged(
        event: React.SyntheticEvent<HTMLInputElement | HTMLSelectElement>
    ) {
        this.setState({
            [event.currentTarget.name]: event.currentTarget.value,
        } as any);
    }

    //private handleInputEmailChanged(
    //    event: React.SyntheticEvent<HTMLInputElement | HTMLSelectElement>
    //) {
    //    const { name, value } = event.currentTarget;

    //    if (name === "customerContactEmail") {
    //        const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    //        this.setState((prevState) => ({
    //            ...prevState,
    //            customerContactEmail: value,
    //            errors: {
    //                ...prevState.errors,
    //                customerContactEmail: value !== "" && !isValidEmail,
    //            },
    //        }));
    //    } else {
    //        this.setState({
    //            [name]: value,
    //        } as any);
    //    }
    //}


    private handleBooleanInputChanged(
        event: React.SyntheticEvent<HTMLInputElement>
    ) {
        this.setState({
            [event.currentTarget.name]: event.currentTarget.value === "true",
        } as any);
    }

    private handleNumberInputChanged(
        event: React.SyntheticEvent<HTMLInputElement | HTMLSelectElement>
    ) {
        this.setState({
            [event.currentTarget.name]: parseInt(event.currentTarget.value, 10),
        } as any);
    }

    private handleAddNewChanged(event: React.SyntheticEvent<HTMLInputElement>) {
        this.setState({
            addNew: event.currentTarget.value === "true",
        });
    }

    private handleAddNewContactChanged(
        event: React.SyntheticEvent<HTMLInputElement>
    ) {
        this.setState({
            addNewContact: event.currentTarget.value === "true",
        });
    }

    private handleCustomerRemoved(
        event: React.SyntheticEvent<HTMLAnchorElement>,
        index: number
    ) {
        event.preventDefault();

        let customers = this.state.customers;
        customers.splice(index, 1);
        this.setState({
            customers: customers,
        });
    }

    private async handleCustomerSelected(value: Option | null) {
        if (value === null) {
            this.setState({
                isCustomerSelected: false,
                contacts: [],
            });
        } else {
            this.getCustomerContacts(value!.value as number);
        }
    }

    private async getCustomerContacts(id: number) {
        let response = await apifetch(`customers/${id}/contacts`, undefined, true);
        if (response.ok) {
            let data = await response.json();
            this.setState({
                isCustomerSelected: true,
                contacts: data,
            });
        }
    }
}

interface ContactPersonProps {
    contactNumber: number;
}

const ContactPerson: React.FC<ContactPersonProps> = ({
    contactNumber,
    ...rest
}) => {
    return (
        <div>
            <div className="row">
                <div className="field-group col-sm-12">
                    <span className="field-label">Contact Person</span>
                    <Select2
                        name={`customerContacts[${contactNumber}][honorificId]`}
                        className="honorific"
                    >
                        <option value="">Select</option>
                        <option value="1">Mr.</option>
                        <option value="2">Mrs.</option>
                        <option value="3">Miss</option>
                    </Select2>
                    <input
                        type="text"
                        name={`customerContacts[${contactNumber}][name]`}
                        className="form-control contact-name"
                        required
                        maxLength={50}
                        onInput={(e) => e.currentTarget.setCustomValidity("")}
                        onInvalid={(e) =>
                            e.currentTarget.setCustomValidity("Contact name is required.")
                        }
                    />
                </div>
            </div>
            <div className="row">
                <div className="field-group col-sm-6">
                    <span className="field-label">Phone</span>
                    <MaskedInput
                        mask={[
                            "(",
                            /[1-9]/,
                            /\d/,
                            /\d/,
                            ")",
                            " ",
                            /\d/,
                            /\d/,
                            /\d/,
                            "-",
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                        ]}
                        name={`customerContacts[${contactNumber}][phone]`}
                        className="form-control"
                        required
                        pattern="\(\d{3}\) \d{3}-\d{4}"
                        onInput={(e) => e.currentTarget.setCustomValidity("")}
                        onInvalid={(e) =>
                            e.currentTarget.setCustomValidity(
                                "Phone number is required and must be in the format of (xxx) xxx-xxxx."
                            )
                        }
                    />
                </div>
                <div className="field-group col-sm-6">
                    <span className="field-label">Title</span>
                    <input
                        type="text"
                        name={`customerContacts[${contactNumber}][title]`}
                        className="form-control"
                        maxLength={50}
                    />
                </div>
            </div>
            <div className="row">
                <div className="field-group col-sm-6">
                    <span className="field-label">Email</span>
                    <input
                        type="email"
                        name={`customerContacts[${contactNumber}][email]`}
                        className="form-control"
                        maxLength={50}
                    />
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./ClientApp/components/quotes/Step2.tsx